/** The corners of an area with a drag applied: the corner at `index` moved, or a new one inserted at `index`. */
export const applyAreaPointDrag = (points, drag) => {
    if (!drag)
        return points;
    return drag.inserted
        ? [...points.slice(0, drag.index), drag.position, ...points.slice(drag.index)]
        : points.map((point, index) => (index === drag.index ? drag.position : point));
};
/** The middle of every edge of a closed area, with the index a corner inserted there gets. */
export const getAreaMidpoints = (points) => {
    if (points.length < 2)
        return [];
    const edgesCount = points.length === 2 ? 1 : points.length;
    return Array.from({ length: edgesCount }, (_value, edgeIndex) => {
        const start = points[edgeIndex];
        const end = points[(edgeIndex + 1) % points.length];
        return {
            index: edgeIndex + 1,
            position: {
                latitude: (start.latitude + end.latitude) / 2,
                longitude: (start.longitude + end.longitude) / 2,
            },
        };
    });
};
